import { RolesTranslation } from './localization/SiteTranslation';

export enum Role {
  Admin = 'Admin',
  Buyer = 'Buyer',
  FlokkSales = 'FlokkSales',
  FlokkSupport = 'FlokkSupport',
  FlokkDigital = 'FlokkDigital',
  Reader = 'Reader',
}

export function isFlokkRole(role: Role) {
  return [Role.FlokkSales, Role.FlokkSupport, Role.FlokkDigital, Role.FlokkDigital].contains(role);
}

export function isFlokkDigitalRole(role: Role) {
  return Role.FlokkDigital === role;
}

export function toRole(roleStr: string) {
  const roleDict = Role as { [key: string]: string };
  for (let roleKey in roleDict) {
    if (roleDict[roleKey] === roleStr) {
      return roleKey as Role;
    }
  }
}

export function localizeRole(roleStr: string, translation: RolesTranslation) {
  const role = toRole(roleStr);
  if (role === undefined) {
    return roleStr;
  }
  const key = role.uncapitalize() as keyof RolesTranslation;
  return translation[key] ?? roleStr;
}
